import {​​​​​ Injectable, Injector }​​​​​ from '@angular/core';
import {​​​​​ HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse }​​​​​ from '@angular/common/http';
import {​​​​​ Observable, pipe }​​​​​ from 'rxjs';
import {​​​​​ finalize, tap }​​​​​ from 'rxjs/operators';
import {​​​​​ LoaderService }​​​​​ from '../services/general/loader.service';
// import {​​​​​ NzMessageService }​​​​​ from 'ng-zorro-antd';
@Injectable({​​​​​
  providedIn: 'root'
}​​​​​)
export class LoaderInterceptor implements HttpInterceptor {​​​​​
  private countRequest = 0;
  constructor(private loaderService: LoaderService,
  ) {​​​​​ }​​​​​
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {​​​​​
    this.showLoader();
    this.countRequest++;
    return next.handle(request)
      .pipe(
        finalize(() => {​​​​​
          this.countRequest--;
          if (this.countRequest === 0) {​​​​​
            this.onEnd();
          }​​​​​
        }​​​​​)
      );
  }​​​​​
  private onEnd(): void {​​​​​
    this.hideLoader();
  }​​​​​
  private showLoader(): void {​​​​​
    this.loaderService.show();
  }​​​​​
  private hideLoader(): void {​​​​​
    this.loaderService.hide();
  }​​​​​
}​​​​​